export function generatePostId(pathname: string) {
  return Buffer.from(pathname.replace(/\/$/, "")).toString("base64");
}
